import _ from 'lodash';
import { SESSION_TIMEOUT_SECONDS } from '../common/config';
import I18n from '../../config/i18n';
import monarch from '../common/clients/monarch';
import { handleAppError } from './app';
import { isSessionExpired } from './isSessionExpired';

const initialState = [];
const RECEIVE = 'timezones/RECEIVE';

export function receiveTimezones(timezones) {
  return { type: RECEIVE, payload: timezones };
}

function pruneDuplicateTimezones(timezones) {
  return _.uniqBy(timezones, 'label');
}

function formatTimezone(timezones) {
  return {
    label: `(UTC ${timezones.utcOffset}) ${timezones.name}`,
    value: timezones.value,
  };
}

export function loadTimezones() {
  let timeZones = sessionStorage.getItem('timeZones');
  let isExpired = isSessionExpired(SESSION_TIMEOUT_SECONDS, 'timezones');

  if (!timeZones || isExpired) {
    return (dispatch) => {
      return monarch
        .get('/v1/timezones')
        .then((res) => res.data.map((timezones) => formatTimezone(timezones)))
        .then((timezones) => pruneDuplicateTimezones(timezones))
        .then((timezones) => {
          sessionStorage.setItem('timeZones', JSON.stringify(timezones));
          dispatch(receiveTimezones(timezones));
        })
        .catch((error) =>
          dispatch(handleAppError(error, I18n.t('unexpectedError'))),
        );
    };
  } else {
    return (dispatch) => {
      dispatch(receiveTimezones(JSON.parse(timeZones)));
    };
  }
}

export default function reducer(state = initialState, action) {
  let { type, payload } = action;
  switch (type) {
    case RECEIVE:
      return payload;

    default:
      return state;
  }
}
